







































































































































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { tooltip } from '@libs-uuif/shared/tooltip-dir';
import { SwTextfield } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { SelectOption, SwSelect } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import { SwButton } from '@libs-uuif/shared/sw-button';
import { InfoState } from '@/core/core.store';
import { envCongif } from '@/shared/env.config';

import Vue from 'vue';

import {
  TableColumnConfig,
  ColumnsAdjustRequestData,
  SwTable,
  TableEntry,
} from '@libs-uuif/shared/sw-table';

const cssPrefix = 'register-cloud-secure-edge';
@Component({
  components: {
    SwTextfield,
    SwSelect,
    SwButton,
    SwTable,

  },
  directives: {
    tooltip,
  },
})
export default class RegisterCloudSecureEdge extends SwExtendedVue {
  cssPrefix = cssPrefix;
  threeAndFree : any = {
    cloudSecureEdgeName:'',
    dataCenterName:'',
  };
  @Prop()
  registerData: any;
  @Prop()
  customerName: any;
  @Prop()
  groupID: any;
  validateData: boolean = false;
  showRegOptions: boolean = false;
  showEmailText: boolean = false;
  isThreeAndFree: boolean = false;
  isCSESeed: boolean = false;
  showTabText: boolean = true;
  showUpgradeButton: boolean = false;
  tableWidth: number = 0;
  dataCenterOptions: SelectOption[] = [];
  tableConfig: TableColumnConfig[] = [];
  tableColumn: TableColumnConfig[] = [];
  tableData: TableEntry[] = [];
  cseAutoRedirect: string;

  get getData(): TableEntry[] {
    return this.tableData;
  }
  onCancel() {
    this.$emit('moveFurther');
  }
  onSubmit() {
    if (this.checkValidity()) {

      const payload  = {
        serialNumber : this.registerData.serialNumber[1],
        groupId : this.groupID,
        cseName : this.threeAndFree.cloudSecureEdgeName,
        dcId : this.threeAndFree.dataCenterName,
        mode  :'ACTIVATE',
        rootServiceId : '',
      };
      this.$store.dispatch('MswProductsStoreModule/actionThreeAndFreeIsCSESeed', payload)
          .then((resp: any) => {
            if (resp.operationStatus === 'OK') {
              const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
              this.$store.commit('enqueueMessage', message);
              if (this.cseAutoRedirect === 'YES') {
                const request = {
                  tenant: this.groupID,
                  tileName: 'ISMSWSAFEENABLED',
                };
                this.$store.dispatch('MswProductsStoreModule/generateCSCCode', request)
                .then((resp: any) => {
                  if (resp?.msgCode === 'MSWAPP:GENERATECSCACCESSCODESUCCESS') {
                    const cscAccessCode = resp?.content?.accessCode;
                    window.open(`${envCongif.spog_url}/muir/spog/login?code=${encodeURIComponent(cscAccessCode)}&mode=tileclick&stile=CSE&tenantid=${this.groupID}`, '_blank');
                  }
                })
                .catch((err: any) => {
                  this.$emit('moveFurther');
                  this.$store.commit('stopLoading');
                  console.error(err);
                })
                .finally(() => {
                  this.$emit('moveFurther');
                  this.$store.commit('stopLoading');
                });
              }
            }
            if (resp.operationStatus === 'NOK') {
              const message: InfoState = { infoType: 'failed', infoMsg: resp.msgDesc };
              this.$store.commit('enqueueMessage', message);
            }
            this.$store.commit('stopLoading');
          })
        .catch((err: any) => {
          this.$store.commit('stopLoading');
          console.warn(err);
        });
    }
  }
  onUpdateRenewEmail(mode : any) {
    const payload  = {
      mode,
      serialNumber : this.registerData.serialNumber[1],
      groupId : this.groupID,
      cseName : this.threeAndFree.cloudSecureEdgeName,
      dcId : this.threeAndFree.dataCenterName,
      rootServiceId : '',
    };
    this.$store.dispatch('MswProductsStoreModule/actionThreeAndFreeIsCSESeed', payload)
    .then((resp: any) => {
      if (resp.operationStatus === 'OK') {
        const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
        this.$store.commit('enqueueMessage', message);
        this.$emit('moveFurther');
        // if (mode !== 'EMAIL KEY') {
        //   this.$emit('moveFurther');
        // } else if (mode === 'EMAIL KEY') {
        //   this.showRegOptions = false;
        //   this.showEmailText = true;
        //   this.showTabText = false;
        // }
      }
      if (resp.operationStatus === 'NOK') {
        const message: InfoState = { infoType: 'failed', infoMsg: resp.msgDesc };
        this.$store.commit('enqueueMessage', message);
      }
      this.$store.commit('stopLoading');
    })
    .catch((err: any) => {
      this.$store.commit('stopLoading');
      console.warn(err);
      if (err.operationStatus === 'NOK') {
        const message: InfoState = { infoType: 'failed', infoMsg: err.msgDesc };
        this.$store.commit('enqueueMessage', message);
      }
    });
  }
  checkValidity() {
    if (this.threeAndFree.cloudSecureEdgeName === '' || this.threeAndFree.dataCenterName === '') {
      this.validateData = true;
    } else {
      return true;
    }
  }
  get tableConfigArr(): TableColumnConfig[] {
    return this.tableColumn;
  }
  mounted() {
    this.$store.dispatch('getAppVersion')
    .then((result: any) => {
      this.cseAutoRedirect = result.content.cseAutoRedirect;
    });
    if (this.registerData.response[1].content.isThreeandFreeCSE === 'YES') {
      this.isThreeAndFree = true;
    }
    if (this.registerData.response[1].content.isCSESeed === 'YES') {
      this.isCSESeed = true;
    }
    if (this.registerData.response[1].content.isCSEAvailable === 'NO') {
      this.showRegOptions = true;
      this.showTabText = false;
      const payload  = {
        serialNumber : this.registerData.serialNumber[1],
        groupId : this.groupID,
        cseName : this.threeAndFree.cloudSecureEdgeName,
        dcId : this.threeAndFree.dataCenterName,
        mode  :'GETDC',
        rootServiceId : '',
      };
      this.$store.dispatch('MswProductsStoreModule/actionThreeAndFreeIsCSESeed', payload)
        .then((resp: any) => {
          this.dataCenterOptions = resp.content.Table.map((item: any) => {
            return {
              id: item.HOSTEDSSEDATACENTERID.toString(),
              label: item.DATACENTER.toString(),
              value: item.HOSTEDSSEDATACENTERID.toString(),
            };
          });
          this.$store.commit('stopLoading');
        })
        .catch((err: any) => {
          this.$store.commit('stopLoading');
          console.warn(err);
        });
    } else {
      const payload  = {
        serialNumber : this.registerData.serialNumber[1],
        groupId : this.groupID,
        cseName : this.threeAndFree.cloudSecureEdgeName,
        dcId : this.threeAndFree.dataCenterName,
        mode  :'GETCSEINFO',
        rootServiceId : '',
      };
      this.$store.dispatch('MswProductsStoreModule/actionThreeAndFreeIsCSESeed', payload)
        // tslint:disable-next-line
        .then((resp: any) => {
          const dataResp = resp.content;
          this.showUpgradeButton = resp.isShowUpgrade;
          if (dataResp.length) {
            this.tableColumn = [
              {
                key: 'updateType',
                dataKey: 'updateType',
                title: '',
                width: 100,
              },
            ];
            const allSpaZero = dataResp.every((item :any) => Number(item.SpaCount) === 0);
            const allSiaZero = dataResp.every((item :any) => Number(item.SiaCount) === 0);
            if (!allSiaZero && !allSpaZero) {
              this.tableWidth = 62;
            } else {
              this.tableWidth = 35.2;
            }
            if (!allSiaZero) {
              this.tableColumn.push(
                {
                  key: 'SiaCount',
                  dataKey: 'SiaCount',
                  title: this.$t('products.SiaCount')
                  .toString(),
                  width: 150,
                },
                {
                  key: 'SiaExpiry',
                  dataKey: 'SiaExpiry',
                  title: this.$t('products.SiaExpiry')
                  .toString(),
                  width: 170,
                },
              );
            }
            if (!allSpaZero) {
              this.tableColumn.push(
                {
                  key: 'SpaCount',
                  dataKey: 'SpaCount',
                  title: this.$t('products.SpaCount')
                  .toString(),
                  width: 150,
                },
                {
                  key: 'SpaExpiry',
                  dataKey: 'SpaExpiry',
                  title: this.$t('products.SpaExpiry')
                  .toString(),
                  width: 170,
                },
              );
            }
          }
          const respData =  dataResp.map((each: any, index: any) => {
            return {
              ...each,
              _key: index.toString(),
            };
          });
          this.tableData = respData;
          this.$store.commit('stopLoading');
        })
        .catch((err: any) => {
          this.$store.commit('stopLoading');
          console.warn(err);
        });
      this.showTabText = true;
      this.showRegOptions = false;
    }
  }
  onRequestColumnAdjust(data: ColumnsAdjustRequestData) {
    this.tableConfig.forEach((col) => {
      const adjustInfo = data[col.key];
      if (!adjustInfo) {
        return;
      }
      Vue.set(col, 'width', adjustInfo);
    });
  }
}
